import { faXmark } from "@fortawesome/pro-regular-svg-icons";
import { DialogTitle, Stack, Typography, useTheme } from "@mui/material";

import { Icon } from "../Icon/Icon";
import { IconButton } from "../IconButton/IconButton";

interface DialogHeaderProps {
  title: string;
  description?: string;
  onClose?: () => void;
  endAction?: React.ReactNode;
}

export const DialogHeader = (props: DialogHeaderProps) => {
  const { title, description, onClose, endAction } = props;
  const theme = useTheme();

  return (
    <DialogTitle>
      <Stack
        direction="row"
        sx={{
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Stack
          direction="row"
          spacing={3}
          sx={{
            alignItems: "baseline",
          }}
        >
          <Typography variant="large" sx={{ fontWeight: "bold" }}>
            {title}
          </Typography>
          {description && (
            <>
              <Typography sx={{ color: theme.palette.secondary[3] }}>
                &#x2022;
              </Typography>
              <Typography
                sx={{
                  [theme.breakpoints.down("md")]: {
                    display: "none",
                  },
                }}
              >
                {description}
              </Typography>
            </>
          )}
        </Stack>
        <Stack
          direction="row"
          spacing={1}
          sx={{
            alignItems: "center",
          }}
        >
          {endAction}
          {onClose && (
            <IconButton
              size="large"
              aria-label="Close Dialog"
              onClick={onClose}
              variant="quaternary"
            >
              <Icon icon={faXmark} />
            </IconButton>
          )}
        </Stack>
      </Stack>
    </DialogTitle>
  );
};
